// file: ToggleSwitch.js
// MODIFIED: Refactored to a generic pure toggle switch.
// Original order-specific Redux logic has been removed.

import React, { useState } from "react";
import styles from "./ToggleSwitch.module.scss";

/**
 * Generic ToggleSwitch component.
 * Props:
 *   checked    {boolean}  - controlled on/off state
 *   onChange   {function} - called with (newValue: boolean) on toggle
 *   disabled   {boolean}  - disables the toggle
 *   label      {string}   - optional label text shown before the switch
 *   className  {string}   - optional wrapper className
 */
const ToggleSwitch = ({
  checked = false,
  onChange,
  disabled = false,
  label = "",
  className = "",
}) => {
  const [internalOn, setInternalOn] = useState(false);
  const isOn = onChange !== undefined ? checked : internalOn;

  const handleToggle = () => {
    if (disabled) return;
    const next = !isOn;
    if (onChange) {
      onChange(next);
    } else {
      setInternalOn(next);
    }
  };

  return (
    <div className={`${styles.container} ${className}`}>
      {label && <span className={styles.label}>{label}</span>}
      <div
        className={styles.wrapper}
        onClick={handleToggle}
        style={{ cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1 }}
      >
        <div className={`${styles.switch} ${isOn ? styles.active : ""}`}>
          <div className={styles.knob}></div>
        </div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
